<template>
  <notify-list/>
  <nav-bar/>
  <router-view class="container view"/>
  <my-counter/>
</template>

<script>
import NavBar from '@/components/UI/NavBar.vue'
import NotifyList from '@/components/UI/NotifyList.vue'
import useAuth from '@/hooks/useAuth'
import useLang from '@/hooks/useLang'
import useProducts from '@/hooks/useProducts'
import productsMixin from '@/mixins/productsMixin.js'
import MyCounter from '@/components/MyCounter'

export default {
  components: { NavBar, NotifyList, MyCounter },

  mixins: [
    productsMixin,
  ],

  beforeCreate() {
    this.validateToken()
    this.checkUserLanguage()
  },

  setup() {
    const { validateToken } = useAuth()
    const { checkUserLanguage } = useLang()
    const { getProducts, findUpdProd } = useProducts()

    return { validateToken, checkUserLanguage, getProducts, findUpdProd }
  }
}
</script>

<style>
</style>